<template>
  <article class="loader" v-if="getLoader">
    <section class="loader_container">
      <div class="spinner-container">
        <span class="spinner"></span>
      </div>
      <img :src="logo" alt="">
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      logoUrl: "https://fusepongsolutions.s3.us-west-2.amazonaws.com/uploads/company/logo/6/8d8bd488-1e73-4086-bed4-4068de70c0e6.png"
    }
  },
  computed: {
    logo() {
      return this.getCompany && this.getCompany.attributes.logo.url ? this.getCompany.attributes.logo.url : this.logoUrl;
    }
  }
}
</script>

<style lang="css">
@-webkit-keyframes load_icon {
  0%{ opacity: 0; }
  50%{ opacity: 1;}
  100%{ opacity: 0; }
}

@keyframes load_icon {
  0%{ opacity: 0; }
  50%{ opacity: 1;}
  100%{ opacity: 0; }
}

.loader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(200,200,200,0.7);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.loader_container {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loader__container img{
  width: 100%;
  height: auto;
  -webkit-animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  -moz-animation: load_icon 1.5s infinite;
  -webkit-animation: load_icon 1.5s infinite;
  animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  animation: load_icon 1.5s infinite;
}

.spinner {
  width: 80px;
  height: 80px;
  border: solid 7px rgba(0, 0, 0, 0.2);
  border-top-color: #0176fb;
  border-radius: 50%;
  animation: spin 2s cubic-bezier(0.59, -0.02, 0.33, 1.01) infinite;
  display: block;
}

@keyframes spin {
    from {transform: rotate(0deg)}
    to {transform: rotate(360deg)}
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    margin: 2rem;
  }



</style>
